import React from "react";

/**
 * Full-screen scrolling background images with copy that stays still
 * (sticky-centred) while the images move behind it on scroll.
 */
export default function ParallaxStory({ images = [], children, testid }) {
  return (
    <div className="relative bg-ink" data-testid={testid}>
      {/* Scrolling image layer */}
      <div className="relative z-0">
        {images.map((src, i) => (
          <div key={i} className="h-screen w-full overflow-hidden">
            <img src={src} alt="" aria-hidden className="w-full h-full object-cover" draggable={false} />
          </div>
        ))}
      </div>

      {/* Still copy layer, sticky over the images */}
      <div className="absolute inset-0 z-10">
        <div className="sticky top-0 h-screen flex items-center justify-center px-6">
          <div className="absolute inset-0 bg-ink/45" />
          <div className="relative max-w-2xl text-center" data-testid={testid ? `${testid}-copy` : undefined}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
